import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseControl } from '../../ui/controls/base-control.model';
import { ViewRowControl } from '../../ui/controls/view-row-control.model';
import { StackLayoutModule } from '@progress/kendo-angular-layout';
import { FormControlComponent } from '../form-control/form-control.component';

@Component({
    selector: 'app-form-row',
    imports: [StackLayoutModule, FormControlComponent, ReactiveFormsModule],
    templateUrl: './form-row.component.html',
    styleUrls: ['./form-row.component.css']
})
export class FormRowComponent {

  @Input() controls: BaseControl[];
  @Input() form: FormGroup;
  @Input() submitted: boolean;
  @Input() row: ViewRowControl;

  constructor() { }

}
